export class CreateGroupModalController {
    static $inject = ['close', '$timeout', 'createGroup'];
    constructor(close, $timeout, createGroup) {
        this.close = close;
        this.$timeout = $timeout;
        this.createGroup = createGroup;
        this.handleGroupNameChange = (event) => {
            this.$timeout(() => {
                this.groupName = event.detail.value.trim();
            });
        };
        this.handleGroupDescriptionChange = (event) => {
            this.$timeout(() => {
                this.groupDescription = event.detail.value.trim();
            });
        };
        this.closeModal = () => {
            this.close();
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.closeModal();
            }
        };
        this.createGroupConfirm = async () => {
            this.closeModal();
            await this.createGroup(this.groupName, this.groupDescription);
        };
    }
    $onInit() {
        document
            .getElementById('create-group-name-input')
            .addEventListener('bdsChange', this.handleGroupNameChange);
        document
            .getElementById('create-group-description-textarea')
            .addEventListener('bdsChange', this.handleGroupDescriptionChange);
        document
            .getElementById('whatsapp-groups-create-modal')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
}
CreateGroupModalController.$inject = ['close', '$timeout', 'createGroup'];
